import useApi from './useApi';

const useProductInventoryService = () => {
  const { api } = useApi();

  const getProductInventory = ({ productId }) => api({
    method: 'get',
    url: `/product-inventory/v1/establishments/own/products/${productId}`,
  });

  const putProductInventory = ({ productId, productInventory }) => api({
    method: 'put',
    url: `/product-inventory/v1/establishments/own/products/${productId}`,
    data: productInventory,
  });

  return {
    getProductInventory,
    putProductInventory,
  };
};

export default useProductInventoryService;
